import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getYoutubeThumb } from 'core/utils';
import Play from 'core/icons/Play';
import loadable from '@loadable/component';
import OverlaySpinner from 'core/ui/OverlaySpinner';

import {
	Wrapper,
	Overlay,
	StyledImg,
} from './youtubeStyles';

const VideoOverlay = loadable(() => import(
	'listing/components/VideoOverlay'
), {
	fallback: <OverlaySpinner />
});

export const YoutubeContainer = ({ youtubeURL }) => {
	const [videoOpen, updateVideoOpen] = useState(false);
	const toggleVideoOpen = () => updateVideoOpen(!videoOpen);
	return (
		<Wrapper>
			<StyledImg src={getYoutubeThumb(youtubeURL)} onClick={toggleVideoOpen} width="345" height="260" />
			{videoOpen && <VideoOverlay url={youtubeURL} dismiss={toggleVideoOpen}/>}
			<Overlay onClick={toggleVideoOpen}>
				<Play />
			</Overlay>
		</Wrapper>
	);
};

YoutubeContainer.propTypes = {
	youtubeURL: PropTypes.string,
};
